import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import API from "../../API/REST_API";
import arrowBackIcon from "../../img/arrow_back_ios-black-36dp.svg";

export default class Login extends Component {
  state = {
    name: "",
    email: "",
    title: "Login",
    loginURL: "/api/v1/auth/login",
    password: "",
    redirect: false,
    error: "",
    signing_in: false,
    emailError: false,
    passwordError: false,
    emailErrorMessage: "",
    passwordErrorMessage: "",
  };

  constructor() {
    super();
    this.state.name = localStorage.getItem("name");
    this.state.email = localStorage.getItem("email");
    this.state.user_img = localStorage.getItem("user_img");
  }

  render() {
    if (this.props.user.logedIn || this.state.redirect)
      return <Redirect to={"/dashboard"} />;

    const login = (
      <span className="flex items-center justify-center gap-2">
        {this.state.signing_in && (
          <svg
            className="h-4 w-4 animate-spin text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        )}
        <span>Login</span>
      </span>
    );
    return (
      <div className="min-h-screen bg-slate-50 px-4 py-10">
        <div className="mx-auto flex min-h-[70vh] w-full max-w-md flex-col items-center">
          <div className="mb-4 flex w-full justify-start">
            <Link
              to="/home"
              className="inline-flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-slate-900"
              aria-label="Back to home"
            >
              <img src={arrowBackIcon} alt="" className="h-5 w-5" />
              Back
            </Link>
          </div>
          <div className="flex w-full flex-1 items-center">
          <div className="w-full rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="mb-6 text-center text-2xl font-semibold text-slate-900">
            {this.state.title}
          </div>

          <div className="space-y-4">
            <div>
              <input
                type="email"
                placeholder="Email"
                className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-slate-500 ${
                  this.state.emailError
                    ? "border-red-500"
                    : "border-slate-300"
                }`}
                autoFocus={true}
                onChange={(e) => {
                  this.onChange("email", e.target.value);
                }}
              />
              {this.state.emailErrorMessage && (
                <div className="mt-1 text-sm text-red-600">
                  {this.state.emailErrorMessage}
                </div>
              )}
            </div>
            <div>
              <input
                type="password"
                placeholder="Password"
                className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-slate-500 ${
                  this.state.passwordError
                    ? "border-red-500"
                    : "border-slate-300"
                }`}
                value={this.state.password}
                onChange={(e) => {
                  this.onChange("password", e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    this.loginHandler();
                  }
                }}
              />
              {this.state.passwordErrorMessage && (
                <div className="mt-1 text-sm text-red-600">
                  {this.state.passwordErrorMessage}
                </div>
              )}
            </div>
            {this.state.error && (
              <div className="text-sm text-red-600">{this.state.error}</div>
            )}
            <button
              type="button"
              disabled={this.state.signing_in}
              className="w-full rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-70"
              onClick={this.loginHandler}
            >
              {login}
            </button>
            <div className="text-right">
              <Link
                to="/forgot-password"
                className="text-sm font-medium text-slate-600 hover:text-slate-900"
              >
                Forgot Password?
              </Link>
            </div>
            <div className="text-center text-sm text-slate-600">
              <span>Don't have an account?</span>{" "}
              <Link to={"/register"} className="font-semibold text-slate-900">
                Sign Up
              </Link>
            </div>
          </div>

          </div>
          </div>
        </div>
      </div>
    );
  }

  onChange(type, value) {
    if (type === "email") {
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      this.setState({
        email: value,
        emailError: value !== "" && !emailValid,
        emailErrorMessage:
          value !== "" && !emailValid ? "Invalid email." : "",
      });
    }
    if (type === "password") {
      this.setState({
        password: value,
        passwordError: false,
        passwordErrorMessage: "",
      });
    }
  }

  logout = () => {
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("user_img");
    this.setState({
      name: "",
      email: "",
    });
    this.props.loginValidate();
  };

  loginHandler = async () => {
    let emailError = false;
    let passwordError = false;
    let emailErrorMessage = "";
    let passwordErrorMessage = "";
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email);
    if (this.state.email === "" || !emailValid) {
      emailError = true;
      emailErrorMessage =
        this.state.email === "" ? "Email is required." : "Invalid email.";
    }
    if (this.state.password === "") {
      passwordError = true;
      passwordErrorMessage = "Password is required.";
    }
    if (emailError || passwordError) {
      this.setState({
        emailError,
        passwordError,
        emailErrorMessage,
        passwordErrorMessage,
        error: "",
      });
      return "";
    }

    this.setState({
      signing_in: true,
    });
    let loginURL = this.props.baseUrl + this.state.loginURL;
    const body = {
      email: this.state.email,
      password: this.state.password,
    };
    // Default options are marked with *

    try {
      const response = await fetch(loginURL, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "include", // include cookies for auth
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(body), // body data type must match "Content-Type" header
      });

      console.log(response);
      const json = await response.json();

      if (response.status === 200) {
        // Reset API session state after successful login
        API.resetSessionState();
        
        // Auth cookies (at/rt) are set automatically by the server response
        localStorage.setItem("first_name", json.user.first_name);
        localStorage.setItem("last_name", json.user.last_name);
        localStorage.setItem("id", json.user.id);
        localStorage.setItem("email", json.user.email);

        this.setState({
          redirect: true,
        });
        // Redirect to dashboard after successful login
        window.location = "/dashboard";
      } else {
        // Handle all error responses (400, 401, etc.)
        let error = "*email or password incorrect. please try again";
        this.setState({ password: "", error, signing_in: false });
      }
      return;
    } catch (error) {
      // eslint-disable-next-line no-ex-assign
      error = "*email or password incorrect. please try again";
      this.setState({ password: "", error, signing_in: false });
    }
  };
}
